import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';
import { operations } from 'api/schema';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export type GetLegalDocumentsFilter = operations['indexLegalDocumentVersions']['parameters']['query'];

async function getLegalDocuments(apiClient: ApiClient, filter: GetLegalDocumentsFilter) {
  return apiClient.GET(`/op/v2/legal-document-versions`, { params: { query: filter } });
}

export function useLegalDocumentsQuery(filter: GetLegalDocumentsFilter) {
  const toast = useToast();
  const navigate = useNavigate();
  const apiClient = useApiClient();

  const query = useQuery<InferFetchData<typeof getLegalDocuments>, ApiError>({
    queryKey: getKey(filter),
    queryFn: () => throwOnError(getLegalDocuments(apiClient, filter)),
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [navigate, query.error, query.isError, toast]);

  return query;
}

export function getKey(filter?: GetLegalDocumentsFilter) {
  return ['LegalDocuments', filter] as const satisfies QueryKey;
}

useLegalDocumentsQuery.getKey = getKey;
